var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"category-filter-buttons"},[_c('tt-filter-reset-button',{attrs:{"disabled":_vm.selectedCategoryCount <= 0},on:{"click":_vm.categorySelectionHandler}}),_vm._l((_vm.categories),function(ref,uuid){
var name = ref.name;
var count = ref.count;
return _c('jz-filter-button',{key:uuid,class:{ selected: _vm.selectedCategoryIds[uuid] },attrs:{"count":count,"data-uuid":uuid},on:{"click":_vm.categorySelectionHandler}},[_vm._v(" "+_vm._s(name)+" ")])})],2)}
var staticRenderFns = []

export { render, staticRenderFns }